import { render } from "./GraphicsDesign.vue?vue&type=template&id=4389c3c6&scoped=true"
import script from "./GraphicsDesign.vue?vue&type=script&lang=js"
export * from "./GraphicsDesign.vue?vue&type=script&lang=js"

import "./GraphicsDesign.vue?vue&type=style&index=0&id=4389c3c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4389c3c6"]])

export default __exports__